import CSessao from '../storage/CSessao';
import CAxiosInstance from './CAxiosInstance';
import type CFiltro from '../api/base/CFiltro';
import type CConsultaValores from '../api/temas/base/CConsultaValores';
import type CConsultaAgregacao from '../api/temas/base/CConsultaAgregacao';
import type CResultadoAgregacao from '../api/temas/base/CResultadoAgregacao';
import type CResponseConsultaPaginada from '../api/base/CResponseConsultaPaginada';

// Shared
import { cBASE_URL_API } from '@/shared/constants/Constantes';

interface IRepositoryControllerAPI<Classe extends Record<string, any>> {
  filtrar(pQuery: CFiltro<Classe>): Promise<CResponseConsultaPaginada<Classe>>;

  agregar(pParams: CConsultaAgregacao<any>): Promise<CResponseConsultaPaginada<CResultadoAgregacao<Classe>>>;

  valores(pParams: CConsultaValores): Promise<string[]>;
}

export default class CBaseControllerAPI<Classe extends Record<string, any>>
  extends CAxiosInstance
  implements IRepositoryControllerAPI<Classe>
{
  constructor() {
    super('API_AGENDAMENTO');
  }

  filtrar(pConsulta: CFiltro<Classe>): Promise<CResponseConsultaPaginada<Classe>> {
    throw new Error('Method not implemented.');
  }

  agregar(pParams: CConsultaAgregacao<any>): Promise<CResponseConsultaPaginada<CResultadoAgregacao<Classe>>> {
    throw new Error('Method not implemented.');
  }

  valores(pParams: CConsultaValores): Promise<string[]> {
    throw new Error('Method not implemented.');
  }

  protected getBaseUrl(): string {
    return cBASE_URL_API;
  }

  protected getTokenAuth(): string {
    return `Bearer ${CSessao.sessaoAtual.token}`;
  }

  static toParamQueryString<T>(pCFiltro?: CFiltro<T>): string {
    if (!pCFiltro || pCFiltro.filtros.length === 0) return '';
    let queryString = '';

    queryString += '?filtros[';

    for (let i = 0; i < pCFiltro.filtros.length; i++) {
      const filtro = pCFiltro.filtros[i];

      queryString += `{"campo": "${String(filtro.campo)}", "operador": "${filtro.operador}", "valor": "${filtro.valor}" }`;

      // Se não for o último filtro, adiciona a vírgula
      if (i < pCFiltro.filtros.length - 1) {
        queryString += ',';
      }
    }

    queryString += ']';
    return queryString;
  }
}
